import { ProductDocument } from "~/ProductDetails/ProductDetailPageResult";

export const getDocumentLink = (doc: ProductDocument) =>
  doc.externalUrl || doc.filePath;

export const getDocumentTitle = (doc: ProductDocument) =>
  doc.externalUrl && doc.externalUrlTitle ? doc.externalUrlTitle : doc.name;

export const getDocumentThumbnail = (doc: ProductDocument) =>
  doc.externalUrl && doc.externalUrlTitle
    ? "//cdnimg.webstaurantstore.com/uploads/design/2020/10/external-link_2x.png"
    : `/images${doc.thumbnailPath}`;

export const getDocumentTypeLabel = (doc: ProductDocument) =>
  doc.type.toLowerCase() === "extra" && doc.customType
    ? doc.customType
    : doc.type;

export const fixDocumentImage = (
  event: React.SyntheticEvent<HTMLImageElement, Event>,
) => {
  if (event.currentTarget.src.endsWith("pdf_no_preview.jpg")) return;
  event.currentTarget.src =
    "//cdnimg.webstaurantstore.com/uploads/design/2025/7/pdf_no_preview.jpg";
};
